import "./index.scss";
import { makeRedemptionInstructions } from "utils/strings";
import { EXTERNAL_LINKS } from "routes/paths";

export const CartTerms = ({ name, terms, cardType }) => {
  const { brand, raise } = terms;
  const { details } = cardType;
  const { cardDetails, deliveryAndRedemption } = details;

  const filterText = (termsText) => termsText.filter((text) => !!text);

  return (
    <div className="cart-terms">
      {!!deliveryAndRedemption.length && (
        <>
          <header className="terms-header">
            <h5 className="terms-title">DELIVERY &amp; REDEMPTION</h5>
          </header>
          <ul className="terms-list">
            {filterText(deliveryAndRedemption).map((text) => (
              <li key={text} className="terms-text">
                {text}
              </li>
            ))}
          </ul>
        </>
      )}

      {!!cardDetails.length && (
        <>
          <header className="terms-header">
            <h5 className="terms-title">CARD DETAILS</h5>
          </header>
          <ul className="terms-list">
            {filterText(cardDetails).map((text) => (
              <li key={text} className="terms-text">
                {text}
              </li>
            ))}
          </ul>
        </>
      )}

      {!!raise && (
        <>
          <header className="terms-header">
            <h5 className="terms-title">TERMS &amp; CONDITIONS</h5>
          </header>
          <h6 className="brand-title">GCX</h6>
          <p className="support">
            For questions about redeeming gift cards, please visit our{" "}
            <a
              className="support-link"
              href={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}
            >
              Help Center
            </a>
          </p>
          <p className="terms-text">{raise}</p>
        </>
      )}
      {!!brand && (
        <>
          <h6 className="brand-title">{name}</h6>
          <p className="terms-text">{makeRedemptionInstructions(brand)}</p>
        </>
      )}
    </div>
  );
};
